export default "__VITE_ASSET__8vsf_u8Y__"